<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="短剧id,外键{zb_video.id}" prop="videoId" >
        <a-input v-model="form.videoId" placeholder="请输入短剧id,外键{zb_video.id}" />
      </a-form-model-item>
      <a-form-model-item label="类型,0-充值订单,1-商品购买,2-shopify商品购买" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="订单id,外键{zb_order.id}" prop="orderId" >
        <a-input v-model="form.orderId" placeholder="请输入订单id,外键{zb_order.id}" />
      </a-form-model-item>
      <a-form-model-item label="商品id,外键{zb_goods.id}" prop="goodsId" >
        <a-input v-model="form.goodsId" placeholder="请输入商品id,外键{zb_goods.id}" />
      </a-form-model-item>
      <a-form-model-item label="shopify订单id,外键{zb_shopify_goods_order.id}" prop="shopifyOrderId" >
        <a-input v-model="form.shopifyOrderId" placeholder="请输入shopify订单id,外键{zb_shopify_goods_order.id}" />
      </a-form-model-item>
      <a-form-model-item label="shopify商品id,外键{zb_shopify_goods.id}" prop="shopifyGoodsId" >
        <a-input v-model="form.shopifyGoodsId" placeholder="请输入shopify商品id,外键{zb_shopify_goods.id}" />
      </a-form-model-item>
      <a-form-model-item label="充值订单id,外键{zb_recharge_order.id}" prop="rechargeOrderId" >
        <a-input v-model="form.rechargeOrderId" placeholder="请输入充值订单id,外键{zb_recharge_order.id}" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getStatistics, addStatistics, updateStatistics } from '@/api/video/statistics'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        videoId: null,

        type: null,

        orderId: null,

        goodsId: null,

        shopifyOrderId: null,

        shopifyGoodsId: null,

        rechargeOrderId: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        videoId: [
          { required: true, message: '短剧id,外键{zb_video.id}不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型,0-充值订单,1-商品购买,2-shopify商品购买不能为空', trigger: 'change' }
        ],
        orderId: [
          { required: true, message: '订单id,外键{zb_order.id}不能为空', trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: '商品id,外键{zb_goods.id}不能为空', trigger: 'blur' }
        ],
        shopifyOrderId: [
          { required: true, message: 'shopify订单id,外键{zb_shopify_goods_order.id}不能为空', trigger: 'blur' }
        ],
        shopifyGoodsId: [
          { required: true, message: 'shopify商品id,外键{zb_shopify_goods.id}不能为空', trigger: 'blur' }
        ],
        rechargeOrderId: [
          { required: true, message: '充值订单id,外键{zb_recharge_order.id}不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoId: null,
        type: null,
        orderId: null,
        goodsId: null,
        shopifyOrderId: null,
        shopifyGoodsId: null,
        rechargeOrderId: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getStatistics({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateStatistics(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addStatistics(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
